






















import { computed, defineComponent, PropType } from "@vue/composition-api";
import { CreditCardAssignment, CreditCardType } from "@scrile/api-provider/dist/api/CreditCardAssignmentsProvider";
import BaseIconButton from "@/components/BaseIconButton";

export default defineComponent({
  name: "CardItem",
  components: { BaseIconButton },
  props: {
    card: { type: Object as PropType<CreditCardAssignment>, required: true },
    info: { type: Object as PropType<{ id: string; name: string }> },
    totalSystems: { type: Number, default: 0 },
  },
  setup(props) {
    const image = computed(() => (props.card.type !== CreditCardType.OTHER ? props.card.type : ""));
    return {
      image,
    };
  },
});
